import { yesNo } from "./yesNo"
import { submissionStatusOptions } from "./submission-status"
import { projectStatusOptions } from "./project-status"
import { stateOption } from "./project-state"
import { getFilterOptions } from "./filter-options"
import { rejectedOnStatusOptions } from "./rejected-on-status"

export const shared = {
  yesNo,
  stateOption,
  getFilterOptions,
  projectStatusOptions,
  submissionStatusOptions,
  rejectedOnStatusOptions
}
